import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Container,
  Button,
  RadioGroup,
  FormControl,
  FormLabel,
} from "@mui/material";
import Input from "../Base/Input";
import Header from "../common/Header";
import IntroCard from "../Cards/IntroCard";
import configData from "../../Config";
import { useNavigate, useLocation } from "react-router-dom";
import SubmitButton from "../common/SubmitButton";
import Backdrop from "../common/Backdrop";
import BasicRadio from "../Base/BasicRadio";
import LoadingDots from "../Lottie/LoadingDots";
import PendingIcon from "@mui/icons-material/Pending";
import VerifiedIcon from "@mui/icons-material/Verified";
import { apis } from "../../services/apiService";
import styles from "../../Style/Modules/pan.module.css";
import "../../Style/Theme/index.css";
import CustAutoComplete from "../../components/Base/AutoComplete";

import Note from "../common/Note";
import {
  VerifyPan,
  alphanumeric,
  constant,
  decryptData,
  encryptData,
  loggerStore,
} from "../../utils/utils";
import PopUp from "../common/PopUp";
import useSelector from "../../store/selector";
import { CONSTANTS } from "../../utils/constant";
export default function PanForm() {
  let location = useLocation();
  // window.history.forward();

  const navigate = useNavigate();
  const initialdata = {
    panCard: location?.state?.panno,
    SallerCode: "",
  };
  const [formData, setFormData] = useState(initialdata);
  const [isFinalError, setIsFinalError] = useState("");
  const [isErrorCode, setIsErrorCode] = useState("");
  const [timeOutErr, setTimeOutErr] = useState("");
  const [loading, setLoading] = useState(false);
  const [aadharLoading, setAadharLoading] = useState(false);
  const [panErr, setPanErr] = useState("");
  const [aadharStatus, setAadharStatus] = useState("");
  const [sallerCodeGetAvailable, setSallerCodeGetAvailable] = useState(false);
  const [sallerCodeDisabled, setSallerCodeDisabled] = useState(true);
  const { setRecoilVal, getRecoilVal } = useSelector();
  const [disabledCheck, setDisabledCheck] = useState("");
  const [Checkone, setCheckone] = useState("");
  const [selectedYear, setSelectedYear] = useState(null);

  const currYear = new Date().getFullYear();
  const yearArr = [];
  let index = 0;
  yearArr.push({ id: 0, year: `below-2000` });
  for (let i = 2001; i <= currYear; i += 5) {
    index++;
    const end = Math.min(i + 4, currYear);
    yearArr.push({ id: index, year: `${i}-${end}` });
  }
  console.log(yearArr);
  const corpCode = {
    0: "Saller Code is required.",
    1: "Saller code should be less than or equal to 18 characters.",
    2: "Only numbers and letters are allowed.",
  };
  let windowOpenVar;
  let clearApiCheck;
  let timer = CONSTANTS.panFormInterval.TIMERINITIAL;
  const getIsSallerCodeAvailable = async () => {
    try {
      let resp = await apis?.getApi(
        `${configData.API_URL}ApplicationFlow/IsCorporateCode?ProgramName=${location.state.program}`
      );

      let result = await resp?.json();
      if (resp?.status === 200) {
        setSallerCodeGetAvailable(result?.data);
      }
    } catch (error) {}
  };

  useEffect(() => {
    getIsSallerCodeAvailable();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const getSplitArr = selectedYear?.year.split("-");
    try {
      let getPreUserDatafromRecoil = getRecoilVal(
        constant.atomsName.USER_DETAIL
      );

      const getDecryptedProgrameName = await decryptData(
        getPreUserDatafromRecoil?.program
      );
      setLoading(true);
      const reqData = {
        aid: location.state.AppId,
        pn: formData?.panCard,
        sellerCode: sallerCodeGetAvailable ? formData?.SallerCode : null,
        txnId: aadharStatus?.txnid,
        PoliticallyExpose: disabledCheck,
        programName: getDecryptedProgrameName,
        minYICD: getSplitArr[0] === "below" ? "0" : getSplitArr[0],
        maxYICD: getSplitArr[1],
      };
      let resp = await apis.postApi(
        `${configData?.API_URL}Pan/Pan_detailed`,
        reqData
      );
      let result = await resp?.json();
      if (resp?.status === 200) {
        setLoading(false);
        loggerStore(
          location?.state?.AppId,
          `Digilocker AddPanTest API response = ${JSON.stringify(result)}`,
          "Information"
        );
        if (result?.data === true) {
          let data = {
            AppId: location?.state?.AppId,
            anchor: location?.state?.anchor,
            program: location?.state?.program,
            source: location?.state?.source,
            userPhoto: aadharStatus?.kycdetails?.pht,
            userName: aadharStatus?.kycdetails?.name,
          };
          navigate("/udhyam-registration", { state: data });
        } else {
          let data = {
            AppId: location?.state?.AppId,
            gstins: result?.data.trim(),
            anchor: location?.state?.anchor,
            program: location?.state?.program,
            source: location?.state?.source,
          };
          navigate("/gst-number", { state: data });
        }
      }
    } catch (error) {
      const errorResult = JSON.parse(error?.message);
      setIsFinalError(errorResult?.statusMessage);
      setLoading(false);
      // let data = {
      //   // for GST  page check after failed
      //   AppId: location.state.AppId,
      //   gstins: "23AKKPM8589N1Z7, 08AAGFA0441H1ZV, 27ABWPH4457M1ZU",
      //   anchor: location.state.anchor,
      //   program: location.state.program,
      //   source: location.state.source,
      //   userPhoto: aadharStatus?.kycdetails?.pht,
      // };
      // navigate("/gst-number", { state: data });
      loggerStore(
        location?.state?.AppId,
        `Digilocker AddPanTest API response for catch= ${JSON.stringify(
          errorResult
        )}`,
        "Information"
      );
      if (
        errorResult?.statusMessage ===
        "You have to wait for sales approval(politically exposed)."
      ) {
        navigate("/error", {
          state: {
            AppId: location.state.AppId,
            H: "Journey Paused",
            Disc: errorResult?.statusMessage,
            // otherMSG:
            //   "Please contact at phone - 9999999999 or email - support@tyger.com",
          },
        });
      }
    }
  };

  let handleCheckOne = (e) => {
    setCheckone(e?.target?.value);
    if (e?.target?.value === "true") {
      setDisabledCheck(true);
    } else {
      setDisabledCheck(false);
    }
  };

  const handleOnChange = (e) => {
    setFormData({ ...formData, [e?.target?.name]: e?.target?.value });
    if (e?.target?.name === "panCard") {
      setIsFinalError("");
      if (e?.target?.value && !VerifyPan(e?.target?.value)) {
        setPanErr("Please enter valid pan details");
        // setCCode("");
      } else {
        setPanErr("");
      }
    }

    if (e?.target?.name === "SallerCode") {
      setIsFinalError("");
      if (e?.target?.value && !alphanumeric(e?.target?.value)) {
        setIsErrorCode(corpCode[2]);
      } else if (e?.target?.value.length === 0) {
        setIsErrorCode(corpCode[0]);
      } else {
        setIsErrorCode("");
      }
    }
  };

  const handleDigilocker = async (e) => {
    windowOpenVar?.close();
    e.preventDefault();
    setAadharLoading(true);
    try {
      // setLoading(true);
      const reqData = {
        aid: location?.state?.AppId,
      };
      let resp = await apis.postApi(
        `${configData?.API_URL}DigilockerController/ValidateAadhar`,
        reqData
      );
      const result = await resp.json();
      loggerStore(
        location?.state?.AppId,
        `Digilocker ValidateAadhar API response = ${JSON.stringify(result)}`,
        "Information"
      );
      if (resp?.status === 200) {
        // setLoading(false);
        windowOpenVar = window.open(result?.data?.url, "_blank");
        digilockerStatusLinkCall();
      }
    } catch (error) {
      const errorResult = JSON.parse(error?.message);
      setAadharLoading(false);
      loggerStore(
        location?.state?.AppId,
        `Digilocker ValidateAadhar API response for catch= ${JSON.stringify(
          errorResult
        )}`,
        "Information"
      );
      // setLoading(false);
    }
  };

  const digilockerStatus = async () => {
    // setLoading(true);
    // aadharLoading === true ? setLoading(false) : setLoading(true);
    let getPreGstDatafromRecoil = getRecoilVal(
      constant.atomsName.AADHAR_DETAILS
    );

    if (getPreGstDatafromRecoil === null) {
      try {
        setAadharLoading(true);
        const reqData = {
          aid: location?.state?.AppId,
        };
        const resp = await apis.postApi(
          `${configData?.API_URL}DigilockerController/FetchTransactionData`,
          reqData
        );
        const result = await resp?.json();
        if (resp?.status === 200) {
          setAadharStatus(result?.data);
          if (result?.data?.status === "Success") {
            setRecoilVal(constant.atomsName.AADHAR_DETAILS, {
              [location?.state?.AppId]: await encryptData(
                JSON.stringify(result?.data)
              ),
            });
            windowOpenVar.close();
            setAadharLoading(false);
            loggerStore(
              location?.state?.AppId,
              `Digilocker FetchTransactionData API response = ${JSON.stringify(
                result
              )}`,
              "Information"
            );
          } else if (result?.data?.status === "pending") {
            setAadharLoading(false);
            loggerStore(
              location?.state?.AppId,
              `Digilocker FetchTransactionData API response = ${JSON.stringify(
                result
              )}`,
              "Information"
            );
          }
        }
      } catch (error) {
        setAadharLoading(false);
        const errorResult = JSON?.parse(error?.message);
        // setTimeOutErr(errorResult?.statusMessage);
        loggerStore(
          location?.state?.AppId,
          `Digilocker FetchTransactionData API response for catch= ${JSON.stringify(
            errorResult
          )}`,
          "Information"
        );
        windowOpenVar?.close();
      }
    } else {
      let decryptedAadhardata = await decryptData(
        getPreGstDatafromRecoil[location?.state?.AppId]
      );
      if (decryptedAadhardata === null) {
        try {
          setAadharLoading(true);
          const reqData = {
            aid: location?.state?.AppId,
          };
          const resp = await apis.postApi(
            `${configData?.API_URL}DigilockerController/FetchTransactionData`,
            reqData
          );
          const result = await resp?.json();
          if (resp?.status === 200) {
            setAadharStatus(result?.data);
            if (result?.data?.status === "Success") {
              setRecoilVal(constant.atomsName.AADHAR_DETAILS, {
                [location?.state?.AppId]: await encryptData(
                  JSON.stringify(result?.data)
                ),
              });
              windowOpenVar.close();
              setAadharLoading(false);
              loggerStore(
                location?.state?.AppId,
                `Digilocker FetchTransactionData API response = ${JSON.stringify(
                  result
                )}`,
                "Information"
              );
            } else if (result?.data?.status === "pending") {
              setAadharLoading(false);
              loggerStore(
                location?.state?.AppId,
                `Digilocker FetchTransactionData API response = ${JSON.stringify(
                  result
                )}`,
                "Information"
              );
            }
          }
        } catch (error) {
          setAadharLoading(false);
          const errorResult = JSON?.parse(error?.message);
          // setTimeOutErr(errorResult?.statusMessage);
          loggerStore(
            location?.state?.AppId,
            `Digilocker FetchTransactionData API response for catch= ${JSON.stringify(
              errorResult
            )}`,
            "Information"
          );
          windowOpenVar?.close();
        }
      } else {
        setAadharStatus(JSON.parse(decryptedAadhardata));
        // setLoading(false);
        setAadharLoading(false);
      }
    }
  };

  let apiTimer = CONSTANTS.panFormInterval.TIMERINITIAL;
  const digilockerStatusLinkCall = async () => {
    // setLoading(true);
    // aadharLoading === true ? setLoading(false) : setLoading(true);
    let getPreGstDatafromRecoil = getRecoilVal(
      constant.atomsName.AADHAR_DETAILS
    );

    if (getPreGstDatafromRecoil === null) {
      try {
        apiTimer++;
        console.log("if null then case");
        setAadharLoading(true);
        // setLoading(true);
        const reqData = {
          aid: location?.state?.AppId,
        };
        const resp = await apis.postApi(
          `${configData?.API_URL}DigilockerController/FetchTransactionData`,
          reqData
        );
        const result = await resp?.json();
        if (resp?.status === 200) {
          setAadharStatus(result?.data);
          if (result?.data?.status === "Success") {
            setRecoilVal(constant.atomsName.AADHAR_DETAILS, {
              [location?.state?.AppId]: await encryptData(
                JSON.stringify(result?.data)
              ),
            });
            windowOpenVar.close();
            setAadharLoading(false);
            loggerStore(
              location?.state?.AppId,
              `Digilocker FetchTransactionData API response = ${JSON.stringify(
                result
              )}`,
              "Information"
            );
          } else if (result?.data?.status === "pending") {
            if (apiTimer < CONSTANTS?.panFormInterval?.MAXTIMER) {
              setTimeout(() => {
                digilockerStatusLinkCall();
              }, CONSTANTS?.panFormInterval?.INTERVALTIMER);
            } else {
              setAadharLoading(false);
              setTimeOutErr(
                "if your aadhar verification is completed kindly refresh the page else complete the verification."
              );
            }
          }
        }
      } catch (error) {
        setAadharLoading(false);
        const errorResult = JSON?.parse(error?.message);
        setTimeOutErr(errorResult?.statusMessage);
        loggerStore(
          location?.state?.AppId,
          `Digilocker FetchTransactionData API response for catch= ${JSON.stringify(
            errorResult
          )}`,
          "Information"
        );
        windowOpenVar?.close();
      }
    } else {
      let decryptedAadhardata = await decryptData(
        getPreGstDatafromRecoil[location?.state?.AppId]
      );
      if (decryptedAadhardata === null) {
        try {
          apiTimer++;
          setAadharLoading(true);
          const reqData = {
            aid: location?.state?.AppId,
          };
          const resp = await apis.postApi(
            `${configData?.API_URL}DigilockerController/FetchTransactionData`,
            reqData
          );
          const result = await resp?.json();
          if (resp?.status === 200) {
            // setLoading(false);
            setAadharStatus(result?.data);
            if (result?.data?.status === "Success") {
              setRecoilVal(constant.atomsName.AADHAR_DETAILS, {
                [location?.state?.AppId]: await encryptData(
                  JSON.stringify(result?.data)
                ),
              });
              windowOpenVar.close();
              setAadharLoading(false);
              loggerStore(
                location?.state?.AppId,
                `Digilocker FetchTransactionData API response = ${JSON.stringify(
                  result
                )}`,
                "Information"
              );
            } else if (result?.data?.status === "pending") {
              if (apiTimer < CONSTANTS?.panFormInterval?.MAXTIMER) {
                setTimeout(() => {
                  digilockerStatusLinkCall();
                }, CONSTANTS?.panFormInterval?.INTERVALTIMER);
              } else {
                setAadharLoading(false);
                setTimeOutErr(
                  "if your aadhar verification is completed kindly refresh the page else complete the verification."
                );
              }
            }
          }
        } catch (error) {
          setAadharLoading(false);
          const errorResult = JSON?.parse(error?.message);
          setTimeOutErr(errorResult?.statusMessage);
          loggerStore(
            location?.state?.AppId,
            `Digilocker FetchTransactionData API response for catch= ${JSON.stringify(
              errorResult
            )}`,
            "Information"
          );
          windowOpenVar?.close();
        }
      } else {
        setAadharStatus(JSON.parse(decryptedAadhardata));
        setAadharLoading(false);
      }
    }
  };

  useEffect(() => {
    digilockerStatus();
  }, []);

  // const statusAPIIntervalCal = () => {
  //   setAadharLoading(true);
  //   const apiCheck = setInterval(() => {
  //     timer += CONSTANTS.panFormInterval.INTERVALTIMER;
  //     if (timer >= CONSTANTS.panFormInterval.MAXTIMER) {
  //       setAadharLoading(false);
  //       clearApiCheck();
  //       setTimeOutErr(
  //         "if your aadhar verification is completed kindly refresh the page else complete the verification."
  //       );
  //     } else {
  //       setAadharLoading(true);
  //       digilockerStatusLinkCall();
  //     }
  //   }, CONSTANTS.panFormInterval.INTERVALTIMER);
  //   clearApiCheck = () => {
  //     setAadharLoading(false);
  //     // setLoading(false);
  //     clearInterval(apiCheck);
  //   };
  // };

  const getSellerCode = async (e) => {
    try {
      setLoading(true);
      let reqData = {
        pan: formData?.panCard,
        anchorName: location?.state?.anchor,
      };
      let resp = await apis?.postApi(
        `${configData?.API_URL}ApplicationFlow/GetSallerCode`,
        reqData
      );
      let result = await resp?.json();
      if (resp?.status === 200) {
        setLoading(false);
        if (result?.data) {
          setFormData({ ...formData, ["SallerCode"]: result?.data });
          if (!alphanumeric(result?.data)) {
            setIsErrorCode(corpCode[2]);
          } else {
            setIsErrorCode("");
          }
          // setSallerCodeGet(result?.data);
          setSallerCodeDisabled(true);
        } else {
          // setSallerCodeGet("");
          setFormData({ ...formData, ["SallerCode"]: "" });
          setSallerCodeDisabled(false);
          setIsErrorCode("No corporate code found, please enter manually");
          setSelectedYear(null);
        }
      }
    } catch (error) {
      const errorResult = JSON?.parse(error?.message);
      setFormData({
        ...formData,
        ["SallerCode"]: errorResult?.data === null ? "" : "",
      });
      setSallerCodeDisabled(false);
      setLoading(false);
      setSelectedYear(null);
      setIsErrorCode(
        errorResult?.statusMessage === "no data found"
          ? "No corporate code found, please enter manually"
          : errorResult?.statusMessage
      );
    }
    // console.log("check happen on blue");
  };

  const handleSelectYear = (e, data, reason) => {
    if (reason !== "clear") {
      if (data) {
        setSelectedYear(data);
      }
    } else {
      setSelectedYear(null);
    }
  };

  return (
    <>
      <Container maxWidth={false} className="container_Th">
        <Header showBar={true} step={1} />
        <IntroCard
          title="Verify your aadhar and pan"
          subtitle="Do
          pan
          verification
          post
          aadhaar
          verification"
          img="/assets/terms.svg"
        />
        <Box
          component="form"
          noValidate
          id="panForm"
          onSubmit={handleSubmit}
          autoComplete="off"
          sx={{
            // backgroundColor: "red",
            marginTop: "-20px",
            height:
              aadharStatus?.status !== "Success" || !aadharStatus
                ? "30vh"
                : "auto",
          }}
        >
          {(aadharStatus?.status !== "Success" || !aadharStatus) && (
            <Note note="Please continue with Digilocker for aadhar verification" />
          )}
          {/* <Note note="Please continue with Digilocker for aadhar verification" /> */}

          <Box
            sx={{
              display: "flex",
              marginTop: aadharStatus?.status === "Success" ? "20px" : "0px",
              // marginBottom: "150px",
              // marginBottom: "115px",
            }}
          >
            <Button
              className="subTitle_Th"
              variant="contained"
              onClick={handleDigilocker}
              disabled={aadharStatus?.status === "Success"}
            >
              Proceed with Digilocker{" "}
            </Button>
            <Box className={styles.panBox}>
              {aadharStatus?.status !== "Success" ? (
                <>
                  <PendingIcon sx={{ color: "#FFA500" }} />
                  <Typography>Pending</Typography>
                </>
              ) : (
                <>
                  <VerifiedIcon sx={{ color: "#6b8e23" }} />
                  <Typography>Verified</Typography>
                </>
              )}
            </Box>
          </Box>

          <Box
            sx={{
              mt: "20px",
              // mt: "-100px",
              // backgroundColor: "red",
              display: aadharStatus?.status === "Success" ? "" : "none", // need to change succsess on urgent
            }}
          >
            <Typography
              className={`${styles.panTypo} panTypo_Th`}
              // onClick={() => setShowAadharModal(true)}
              //      data = {
              //   AppId: location?.state?.AppId,
              // };
              onClick={() =>
                navigate("/pan/Aadhar_Detail", {
                  state: { AppId: location?.state?.AppId },
                })
              }
            >
              Click here to check your aadhar details
            </Typography>
            <Input
              type="text"
              name="panCard"
              autoComplete="off"
              label="Pan card number"
              value={formData?.panCard}
              error={panErr}
              onChange={handleOnChange}
              onBlur={(e) => {
                sallerCodeGetAvailable && getSellerCode(e);
              }}
            />
            {panErr && (
              <Typography className={`${styles.panTypo1} errorMsg_Th`}>
                {panErr}
              </Typography>
            )}
            {sallerCodeGetAvailable && (
              <Input
                type="text"
                name="SallerCode"
                autoComplete="off"
                label="Seller Code"
                // value={sallerCodeGet || formData?.SallerCode}
                value={formData?.SallerCode}
                // error={isErrorCode}
                onChange={handleOnChange}
                disabled={sallerCodeDisabled || !formData?.panCard || panErr}
              />
            )}
            {isErrorCode && (
              <Typography
                className="errorMsg_Th"
                sx={{
                  // color: "red",
                  mt: "-30px",
                  position: "absolute",
                  ml: "5px",
                }}
              >
                {isErrorCode}
              </Typography>
            )}
            <CustAutoComplete
              label="Year of incorporation of business?"
              key="id"
              value={selectedYear}
              options={yearArr}
              optionLabelName={"year"}
              uniqueKey={"id"}
              onChange={handleSelectYear}
              disabled={
                sallerCodeGetAvailable && (!formData?.SallerCode || isErrorCode)
              }
            />
            <Box sx={{ display: "flex", mt: "15px" }}>
              <FormControl>
                <FormLabel id="demo-row-radio-buttons-group-label">
                  Are you a Politically Exposed Person?
                </FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="PoliticallyExposed"
                  value={Checkone}
                  onChange={handleCheckOne}
                >
                  <BasicRadio value="true" label="Yes" />
                  <BasicRadio value="false" label="No" />
                </RadioGroup>
              </FormControl>
            </Box>
            {isFinalError && (
              <Typography
                className="errorMsg_Th"
                sx={{
                  // color: "red",
                  mt: "-10px",
                  position: "absolute",
                  ml: "5px",
                }}
              >
                {isFinalError}
              </Typography>
            )}
          </Box>
          {loading && (
            <Backdrop ax="center">
              <LoadingDots />
            </Backdrop>
          )}
          {timeOutErr && (
            <Typography
              className="errorMsg_Th"
              sx={{
                // color: "red",
                mt: "20px",
                ml: "5px",
              }}
            >
              {timeOutErr}
            </Typography>
          )}
          {aadharLoading && (
            <Backdrop ax="center">
              <LoadingDots
                displayText={
                  aadharStatus?.status === "pending"
                    ? "Aadhar Verification is in progress"
                    : ""
                }
              />
            </Backdrop>
          )}
          <SubmitButton
            hasNote="No"
            disabled={
              (sallerCodeGetAvailable &&
                (!formData?.SallerCode || isErrorCode)) ||
              !formData?.panCard ||
              panErr ||
              !Checkone ||
              !selectedYear ||
              isFinalError
            }
            panBtn="PanBTN"
          />
        </Box>
      </Container>
    </>
  );
}
